module.exports = __webpack_public_path__ + "static/media/N8.14538791.jpg";